<template>
    <div :class="['horizontal-report-nav', { dark: theme == THEMES.DARK }]">
        <div class="nav-container">
            <div class="nav-categories">
                <div v-for="(sidebarLinkGroup, i) of sidebarLinks" :key="i" class="nav-category">
                    <HorizontalNavGroup :sidebarLinkGroup="sidebarLinkGroup" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import HorizontalNavGroup from "./HorizontalNavGroup.vue"
import { PERMISSION_CODES } from "../../../store/permission"

function reportLink(link, title, permission) {
    return {
        link: `/reports/${link}`,
        title,
        permission,
    }
}

export default {
    computed: {
        ...mapState("auth", ["authenticated", "user"]),
        ...mapState("misc", ["showSidebar", "theme", "THEMES"]),
    },
    components: { HorizontalNavGroup },
    data() {
        return {
            sidebarLinks: [
                {
                    title: "Cash Management",
                    icon: "account_balance_wallet",
                    data: [reportLink("cash-management", "Cash Management", PERMISSION_CODES.CMS_VIEW_REPORT_CASH_MANAGEMENT)],
                },
                {
                    title: "Customer",
                    icon: "people",
                    data: [reportLink("customer", "New Customers", PERMISSION_CODES.CMS_VIEW_REPORT_CUSTOMER)],
                },
                {
                    title: "Finance",
                    icon: "account_balance",
                    data: [
                        reportLink("gl-account-totals", "GL Account Totals", PERMISSION_CODES.CMS_VIEW_REPORT_GL_ACCOUNT_TOTALS),
                        reportLink("gl-transactions", "GL Transactions", PERMISSION_CODES.CMS_VIEW_REPORT_GL_TRANSACTIONS),
                    ],
                },
                {
                    title: "Inventory",
                    icon: "inventory_2",
                    data: [
                        reportLink("inventory-on-hand", "Inventory On Hand", PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_ON_HAND),
                        reportLink("inventory-last-received", "Inventory Last Received", PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_ON_HAND),
                        reportLink("inventory-adjustment", "Inventory Adjustments", PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_ADJUSTMENT),
                        // reportLink("inventory-transaction", "Inventory Transactions"),
                        {
                            ...reportLink("room-movement", "Room Movement", PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_TRANSFER),
                            // Preserve both existing gates: the page needs TRANSFER; its API needs ON_HAND.
                            requiredPermissions: [PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_ON_HAND],
                        },
                        reportLink("transfer", "Transfers", PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_TRANSFER),
                        reportLink("purchase-order", "Purchase Orders", PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_PURCHASE_ORDER),
                    ],
                },
                {
                    title: "Sales",
                    icon: "point_of_sale",
                    data: [
                        reportLink("sale-end-of-day", "End of Day", PERMISSION_CODES.CMS_VIEW_REPORT_END_OF_DAY),
                        reportLink("sale-report", "Sales by Invoice", PERMISSION_CODES.CMS_VIEW_REPORT_SALES_REPORT),
                        reportLink("sale-by-classification", "Sales by Classification", PERMISSION_CODES.CMS_VIEW_REPORT_SALES_BY_CLASSIFICATION),
                        reportLink("sale-by-product", "Sales By Product", PERMISSION_CODES.CMS_VIEW_REPORT_SALES_BY_PRODUCT),
                        reportLink("sale-by-location", "Sales By Location", PERMISSION_CODES.CMS_VIEW_REPORT_SALES_BY_LOCATION),
                        reportLink("sale-by-employee", "Sales By Employee", PERMISSION_CODES.CMS_VIEW_REPORT_SALES_BY_EMPLOYEE),
                        
                        // Enhanced Reports
                        reportLink("discount-report", "Discount Report", PERMISSION_CODES.CMS_VIEW_REPORT_DISCOUNT_REPORT),
                        reportLink("skipping-report", "Skipping Report", PERMISSION_CODES.CMS_VIEW_REPORT_SKIPPING_REPORT),
                        reportLink("drawer-action-report", "Drawer Action Report", PERMISSION_CODES.CMS_VIEW_REPORT_DRAWER_ACTION_REPORT),
                    ],
                },
            ],
        }
    },
    methods: {
        ...mapActions("misc", ["setData"]),

        toggleShowSidebar() {
            this.setData({
                showSidebar: !this.showSidebar,
            })
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.horizontal-report-nav {
    background: $lightCardBg;
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid $lightBorderColor;
    overflow: visible;
    position: relative;
    z-index: 1000;
    
    &.dark {
        background: $darkCardBg;
        border-color: $darkBorderColor;
    }
}

.nav-container {
    padding: 20px 24px;
    position: relative;
    z-index: 1001;
}

.nav-categories {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    align-items: flex-start;
}

.nav-category {
    flex-shrink: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
    .nav-container {
        padding: 16px 20px;
    }
    
    .nav-categories {
        gap: 6px;
    }
}
</style>
